import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./components/context/authcontext";
import ProtectedRoute from "./components/routes/protectedroute";

import Layout from "./components/homepage/layout";
import Login from "./components/auth/login";
import ForgotPassword from "./components/auth/forgot_password";
import Dashboard from "./components/dashboard/dashboard";
import Employee from "./components/employee/employee";
import EmployeeFormPage from "./components/employee/employee_form_page";
import Task from "./components/task/task";
import Attendance from "./components/attendance/attendance";

import DSRManagement from "./components/dsr/dsr";
import ProfilePage from "./components/profile/profile";
// eslint-disable-next-line no-unused-vars
import Projects from "./components/project/project";
// eslint-disable-next-line no-unused-vars
import Team from "./components/teams/team";
import Department from "./components/department/department";
import Designation from "./components/designation/designation";
// eslint-disable-next-line no-unused-vars
import Clients from "./components/clients/clients";
// eslint-disable-next-line no-unused-vars
import Leaves from "./components/leaves/leaves";
// eslint-disable-next-line no-unused-vars
import WorkCalendar from "./components/workcalendar/workcalendar";
import Users from "./components/users/users";
import RoleManagement from "./components/rbac/role_management";
import NotificationsPage from "./components/notifications/notifications";
import { Unauthorized401, AccessDenied403, NotFound404, ServerError500 } from "./components/common/error_pages";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Default → Login */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot_password" element={<ForgotPassword />} />
          <Route path="/401" element={<Unauthorized401 />} />
          <Route path="/403" element={<AccessDenied403 />} />
          <Route path="/404" element={<NotFound404 />} />
          <Route path="/500" element={<ServerError500 />} />

          {/* Protected layout */}
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard"     element={<Dashboard />} />
            <Route path="/employee"      element={<ProtectedRoute requiredPerm="employee.view"><Employee /></ProtectedRoute>} handle={{ crumb: "Employees" }} />
            <Route path="/employee/add"  element={<ProtectedRoute requiredPerm="employee.create"><EmployeeFormPage /></ProtectedRoute>} handle={{ crumb: "New Employee" }} />
            <Route path="/employee/edit/:id" element={<ProtectedRoute requiredPerm="employee.update"><EmployeeFormPage /></ProtectedRoute>} handle={{ crumb: "Edit Employee" }} />
            <Route path="/task"          element={<ProtectedRoute requiredPerm="task.view"><Task /></ProtectedRoute>} />
            <Route path="/attendance"    element={<ProtectedRoute requiredAnyPerm={["attendance.view", "regularization.view", "regularization.create"]}><Attendance /></ProtectedRoute>} />
            <Route path="/dsr"           element={<ProtectedRoute requiredAnyPerm={["dsr.view", "dsr.view_others"]}><DSRManagement /></ProtectedRoute>} />
        {/* <Route path="/project"       element={<ProtectedRoute requiredPerm="project.view"><Projects /></ProtectedRoute>} />
            <Route path="/team"          element={<ProtectedRoute requiredPerm="team.view"><Team /></ProtectedRoute>} /> */}
            <Route path="/profile"       element={<ProfilePage />} />    
             <Route path="/leaves"        element={<ProtectedRoute requiredPerm="leave.view"><Leaves /></ProtectedRoute>} />
            <Route path="/department"    element={<ProtectedRoute requiredPerm="department.view"><Department /></ProtectedRoute>} />
            <Route path="/designation"   element={<ProtectedRoute requiredPerm="designation.view"><Designation /></ProtectedRoute>} />
            {/* <Route path="/clients"       element={<ProtectedRoute requiredPerm="client.view"><Clients /></ProtectedRoute>} />
           
            <Route path="/work-calendar" element={<ProtectedRoute requiredAnyPerm={["shift.view", "holiday.view", "weekend_policy.view"]}><WorkCalendar /></ProtectedRoute>} /> */}
            <Route path="/users"         element={<ProtectedRoute requiredPerm="user.view"><Users /></ProtectedRoute>} />
            <Route path="/roles"         element={<ProtectedRoute requiredAnyPerm={["role.view", "permission.view"]}><RoleManagement /></ProtectedRoute>} />
            <Route path="/notifications"  element={<ProtectedRoute requiredPerm="notification.view"><NotificationsPage /></ProtectedRoute>} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<NotFound404 />} />
        </Routes>

        <ToastContainer
          position="top-right"
          autoClose={2500}
          hideProgressBar={true}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="light"
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;